const options = {
    scroll: false,
    update: false
};
export default options;
